import { useState, useEffect, useContext } from 'react'

export const usePaginate = (list = [], sizePage = 7): any => {
    const [numPage, setNumPage] = useState<any>(1)

    const paginate = (list, numPage = 1) => {
        setNumPage(numPage)

        return list?.slice(0, numPage * sizePage)
    }

    return { sizePage, numPage, paginate }
}
